module.exports = __webpack_public_path__ + "static/img/zfb.0390d24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zfb.jpg
// module id = 4AN5
// module chunks = 1